export default {
  latest_terms_of_use: {}
  // latest_terms_of_use_to_accept: {}
};
